import { render, staticRenderFns } from "./SelectMediaFolderModal.vue?vue&type=template&id=49f7af81&scoped=true&"
import script from "./SelectMediaFolderModal.vue?vue&type=script&lang=ts&"
export * from "./SelectMediaFolderModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMediaFolderModal.vue?vue&type=style&index=0&id=49f7af81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f7af81",
  null
  
)

export default component.exports